var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { doGetJSON } from '../base/util/httpUtils';
import { SET_DYNAMIC_BRANDING_DATA, SET_DYNAMIC_BRANDING_FAILED, SET_DYNAMIC_BRANDING_READY } from './actionTypes';
import { getDynamicBrandingUrl } from './functions.any';
import logger from './logger';
/**
 * Fetches custom branding data.
 * If there is no data or the request fails, sets the `customizationReady` flag
 * so the defaults can be displayed.
 *
 * @returns {Function}
 */
export function fetchCustomBrandingData() {
    return function (dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = getState();
            const { customizationReady } = state['features/dynamic-branding'];
            if (!customizationReady) {
                const url = yield getDynamicBrandingUrl(state);
                if (url) {
                    try {
                        const res = yield doGetJSON(url);
                        return dispatch(setDynamicBrandingData(res));
                    }
                    catch (err) {
                        logger.error('Error fetching branding data', err);
                        return dispatch(setDynamicBrandingFailed());
                    }
                }
                dispatch(setDynamicBrandingReady());
            }
        });
    };
}
/**
 * Action used to set the user customizations.
 *
 * @param {Object} value - The custom data to be set.
 * @returns {Object}
 */
export function setDynamicBrandingData(value) {
    return {
        type: SET_DYNAMIC_BRANDING_DATA,
        value
    };
}
/**
 * Action used to signal the branding elements are ready to be displayed.
 *
 * @returns {Object}
 */
export function setDynamicBrandingReady() {
    return {
        type: SET_DYNAMIC_BRANDING_READY
    };
}
/**
 * Action used to signal the branding request failed.
 *
 * @returns {Object}
 */
export function setDynamicBrandingFailed() {
    return {
        type: SET_DYNAMIC_BRANDING_FAILED
    };
}
